import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import queryString from "query-string";

import { PAGE_TYPE, setPageTitle, getIsGoogleMode } from "containers/App/reducer";

import * as loginReducer from "containers/Login/reducer";

import TableauProjectsWarning from "components/WarningBanner/TableauProjectsWarning";
import DataReadinessWarning from "components/WarningBanner/DataReadinessWarning";
import ServerWarning from "components/WarningBanner/ServerWarning";
import ChatAibleBetaWarning from "components/WarningBanner/ChatAibleBetaWarning";

class WarningBanner extends React.PureComponent {
  render() {
    const { type } = this.props;
    switch (type) {
      case "aible_data_readiness_warning":
        return <DataReadinessWarning {...this.props} />;
      case "aible_tableau_projects_warning":
        return <TableauProjectsWarning {...this.props} />;
      case "chat_aible_beta_warning":
        return <ChatAibleBetaWarning {...this.props} />;
      case "aible_server_warning":
      default:
        return <ServerWarning {...this.props} />;
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  storeItem: (key, value) => dispatch(loginReducer.storeItem(key, value)),
  getItem: (key) => dispatch((dispatch, getState) => loginReducer.getItem(getState(), key)),
  removeItem: (key) => dispatch(loginReducer.removeItem(key))
});

const mapStateToProps = (state, ownProps) => {
  return {};
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(WarningBanner);
